import { render, staticRenderFns } from "./BaseAction.vue?vue&type=template&id=1d8fa68a&"
import script from "./BaseAction.vue?vue&type=script&lang=js&"
export * from "./BaseAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports